module.exports = __webpack_public_path__ + "img/personal-general-logo.ce60dd4f.png";